import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import { ChevronDown } from 'lucide-react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@cargomatic/ui';
import StandardAccessorialRates from '../modals/StandardAccessorialRates';

export function StandardRatesModal({ show, onHide, markets, type, canUpdate }) {
  const { t } = useTranslation();
  const [selectedMarkets, setSelectedMarkets] = useState([]);

  const handleHide = () => {
    setSelectedMarkets([]);
    onHide();
  };

  const handleToggleMarket = (name, checked) => {
    setSelectedMarkets((prev) =>
      checked ? [...prev, name] : prev.filter((m) => m !== name),
    );
  };

  const label =
    selectedMarkets.length > 0
      ? `${t('MARKET', { count: 1 })} (${selectedMarkets.length})`
      : t('SELECT_MARKET');

  return (
    <Dialog
      open={show}
      onOpenChange={(open) => {
        if (!open) handleHide();
      }}
    >
      <DialogContent className="sm:max-w-[900px] max-h-[85vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>{titleize(type)} Standard Accessorial Card</DialogTitle>
        </DialogHeader>
        <div className="mb-4">
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="outline" className="gap-1">
                {label}
                <ChevronDown className="h-4 w-4" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent className="max-h-60 overflow-y-auto w-56">
              {(markets || []).map((name) => (
                <DropdownMenuCheckboxItem
                  key={name}
                  checked={selectedMarkets.includes(name)}
                  onCheckedChange={(checked) =>
                    handleToggleMarket(name, checked)
                  }
                >
                  {titleize(name)}
                </DropdownMenuCheckboxItem>
              ))}
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
        {selectedMarkets.length > 0 && (
          <StandardAccessorialRates
            key={`${type}-${selectedMarkets.join(',')}`}
            markets={selectedMarkets}
            canUpdate={canUpdate}
            type={type}
            onHide={handleHide}
          />
        )}
      </DialogContent>
    </Dialog>
  );
}
